module.exports = __webpack_public_path__ + "img/gjgj.b3eb8ed0.png";